const themeSimple = {
  layoutType: 'full',
  common: {
    color: '##00bf6f',
    backgroundColor: '#fff',
    fontFamily: 'Arial, sans-serif',
  },
  palette: {
    color: '#00bf6f',
    backgroundColor: '#fff',
    fontFamily: 'National2',
    fontSize: '26px',
    fontWeight: '700',
  },
  layout: {},
};

const themeCompany = {
  layoutType: 'left_half',
  common: {
    color: '#fff',
    backgroundColor: '#333e48',
    fontFamily: 'Raleway,Arial,Helvetica',
  },
  palette: {
    color: '#fff',
    backgroundColor: '#333e48',
    fontFamily: 'Playfair Display,Times',
    fontSize: '38px',
    fontWeight: '700',
  },
  layout: {
    backgroundPosition: '50% 50%',
    backgroundSize: 'cover',
    backgroundImage: 'url(//sm-assets-mt3.s3.amazonaws.com/smtheme3/stock/c6c1a1f7-34cc-527d-b6b9-ce43ada7e5cc.jpg)',
  },
};

export { themeCompany, themeSimple };
